// extracted by mini-css-extract-plugin
module.exports = {"test-button":"CFEkN6DZuKhRY8_JFgbj9","test-summary":"_1lIG_mZRTfoXzBglgymaRS","results":"_101UAvlX_xA4BJxd-L1mT"};